e4.product = {
    debug: false,
    init: function () {
        if ( jQuery( '.js-e-product-form, .js-e-productlist' ).length > 0 ) {
            e4.require.js( e4.settings.require.jQueryValidate, function () {
                e4.product.bindEvents();
                e4.product.variants.init();
            } );
        }
        jQuery( '.js-e-product-images, #js-e-product-image-modal' ).on( 'loaded.e4.jsonpublisher', '.js-e-jsonpublisher', function ( event ) {
            jQuery( event.target ).on( 'mouseenter', '.carousel-indicators li', function ( event ) {
                jQuery( event.target ).trigger( 'click' );
            } );
        } );

        jQuery( '.js-theca-product-combinations' ).on( 'loaded.e4.jsonpublisher', '.js-e-jsonpublisher', function ( event ) {
            var intCombinationCount = jQuery( '.js-theca-combination-products' ).data( 'count' );
            if(jQuery('.js-variant-orientation').length > 0){
                jQuery( '.js-e-product' ).on( 'change', '.js-variant-orientation', function ( event ) {
                    var jElementFlipper = jQuery(event.target).closest('.js-e-productlist-item').find('.theca-flipper');
                    if(jElementFlipper.hasClass('is-flipped')){
                        jElementFlipper.removeClass('is-flipped');
                    } else {
                        jElementFlipper.addClass('is-flipped');
                    }
                } );
            }

            if ( intCombinationCount > 1 ) {
                jQuery( '.js-combination-products-count' ).html( jQuery( '.js-theca-combination-products' ).data( 'count' ) );
                //jQuery( '.js-combination-products-count' ).closest( '.js-theca-combination-selector' ).removeClass( 'd-none' );
            }
            else {
                //jQuery( '.js-combination-products-count' ).closest( '.js-theca-combination-selector' ).remove();
            }
        } );
    },
    bindEvents: function () {

        jQuery( '.js-e-product-form' ).each( function ( intIndex, domForm ) {
            e4.product.validateForm( domForm );
        } );
        jQuery( '.js-e-productlist' ).on( 'builded.e4.productlist', function ( event ) {
            jQuery( event.target ).find( '.js-e-product-form' ).each( function ( intIndex, domForm ) {
                e4.product.validateForm( domForm );
            } );
        } );
        if ( jQuery( '.js-e-product-favorite-list-form' ).length > 0 ) {
            e4.product.favoritelist.bindEvents();
        }

        if ( jQuery( '.js-theca-accessories-productlist' ).length > 0 ) {
            jQuery( '.js-theca-accessories-productlist' ).on( 'change', '.js-theca-checkbox-accessories', function ( event ) {
                e4.product.includeAccessories( event.target );
            } );
        }
        if ( jQuery( '.js-e-product' ).find( 'input[name="Quantity0"]' ).length > 0 ) {
            jQuery( '.js-e-product' ).on( 'change', 'input[name="Quantity0"]', function ( event ) {
                e4.product.updateAccessories( event.target );
            } );
        }
        e4.product.calcTotalPrice();
    },
    arrIncludedAccessories: [],
    onPageLoad: true,
    setAccessories: function () {
        jQuery('.js-theca-checkbox-accessories').each(function ( intIndex, domElement ) {
            if(e4.product.onPageLoad && jQuery(domElement).attr('id').toString().toLowerCase().indexOf('footrest') > -1){
                jQuery( '.js-theca-checkbox-accessories[data-title="' + jQuery(domElement).data('title') + '"]' ).prop( 'checked', true ).trigger( 'change' );
            } else {
                jQuery( '.js-theca-checkbox-accessories[data-title="' + jQuery(domElement).data('title') + '"]' ).prop( 'checked', (e4.product.arrIncludedAccessories.indexOf(jQuery(domElement).data('title')) > -1) ).trigger( 'change' );
            }
        } );
        e4.product.onPageLoad = false;
        //setTimeout(e4.product.calcTotalPrice(), 1000);
    },
    updateAccessories: function ( domTarget ) {
        jQuery( '.js-theca-accessories-productlist' ).find( '.js-theca-checkbox-accessories' ).each( function ( intIndex, domElement ) {
            e4.product.includeAccessories( domElement );
        } );
    },
    includeAccessories: function ( domTarget ) {
        var jElementQuantity = jQuery( domTarget ).closest( '.js-theca-accessories-item' ).find( '.js-theca-accessories-quantity' );
        if ( jQuery( domTarget ).prop( 'checked' ) ) {
            jElementQuantity.val( jQuery( '.js-e-product' ).find( 'input[name="Quantity0"]' ).val() );
            jElementQuantity.addClass('d-inline-flex').removeClass('d-none');
            if ( e4.product.arrIncludedAccessories.indexOf( jQuery( domTarget ).data( 'title' ) ) === -1 ) {
                e4.product.arrIncludedAccessories.push( jQuery( domTarget ).data( 'title' ) );
            }
        }
        else {
            jElementQuantity.val( 0 );
            jElementQuantity.addClass('d-none').removeClass('d-inline-flex');
            e4.product.arrIncludedAccessories = jQuery.grep( e4.product.arrIncludedAccessories, function ( strValue ) {
                return strValue !== jQuery( domTarget ).data( 'title' );
            } );
        }
        e4.product.calcTotalPrice();
    },
    calcTotalPrice: function(){
        var mainProductQuantity = jQuery( '.js-e-product' ).find( 'input[name="Quantity0"]' ).val(),
            mainProductUnitPrice = jQuery('.js-theca-product-price-formatted').data('unitprice'),
            calculatedPrice = mainProductQuantity * mainProductUnitPrice;

        jQuery( '.js-theca-accessories-productlist' ).find( '.js-theca-checkbox-accessories' ).each( function ( intIndex, domElement ) {
            if(jQuery(domElement).prop('checked')){
                var accessoryProductQuantity = jQuery(domElement).closest('div').find('.js-theca-accessories-quantity').val();
                var accessoryProductUnitPrice = jQuery(domElement).data('unitprice');
                calculatedPrice += (accessoryProductQuantity * accessoryProductUnitPrice);
                //console.log('acc price', accessoryProductQuantity, accessoryProductUnitPrice, accessoryProductQuantity * accessoryProductUnitPrice);
            }
        } );

        if(isNaN(calculatedPrice) || mainProductUnitPrice === 0){
            jQuery('.js-theca-product-price-formatted').text('Price will be updated');
        } else {
            jQuery('.js-theca-product-price-formatted').html(e4.product.priceFormatted(calculatedPrice, true));
        }
        
        
        jQuery('.js-theca-product-price-formatted').removeClass('d-none');
    },
    priceFormatted: function(num, includeCurrency) {
        var cartForm = jQuery('.js-theca-product-form-addtocart'),
            charDecimalSeparator = cartForm.data('currencydecimalseparator'),
            charGroupSeparator = cartForm.data('currencygroupseparator'),
            strCurrencyCode = cartForm.data('currencycode'),
            strCurrencysymbol = cartForm.data('currencysymbol'),
            intCurrencysymbolplace = cartForm.data('currencysymbolplace'),
            returnValue = num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
        returnValue = returnValue.split('.').join('_');
        returnValue = returnValue.split(',').join(charGroupSeparator);
        returnValue = returnValue.split('_').join(charDecimalSeparator);
        if(includeCurrency){
            if(intCurrencysymbolplace === 0){
                returnValue = strCurrencysymbol + ' ' + returnValue;
            } else {
                returnValue = returnValue + ' ' + strCurrencyCode;
            }
        }
        return returnValue;
    },
    validateForm: function ( domForm ) {
        var jForm = jQuery( domForm );
        jForm.validate( {
            submitHandler: function ( domForm ) {
                if ( jForm.is( '.js-e-product-form-removefromcart' ) === true ) {
                    e4.product.removeFromCart( domForm );
                }
                else /* if ( jForm.is( '.js-e-product-form-addtocart' ) === true )*/ {
                    e4.product.addToCart( domForm );
                }
            }
        } );
    },
    addToCart: function ( domForm ) {
        var jForm = jQuery( domForm ),
            arrFormData = jForm.serializeArray(),
            objFormData = {};
        for ( var i = 0; i < arrFormData.length; i++ ) {
            objFormData[ arrFormData[ i ].name ] = arrFormData[ i ].value;
        }
        jQuery.extend( objFormData, {
            Redirect: false
        } );

        if ( jForm.is( '.js-e-product-form-download' ) === true ) {
            e4.download.cart.addProduct( objFormData );
        }
        else {
            e4.cart.addProduct( objFormData );
        }


    },
    removeFromCart: function ( domForm ) {
        var jForm = jQuery( domForm ),
            arrFormData = jForm.serializeArray(),
            objFormData = {};
        for ( var i = 0; i < arrFormData.length; i++ ) {
            objFormData[ arrFormData[ i ].name ] = arrFormData[ i ].value;
        }
        jQuery.extend( objFormData, {
            Redirect: false
        } );
        if ( jForm.is( '.js-e-product-form-download' ) === true ) {
            e4.download.cart.removeProduct( objFormData );
        }
        else {
            e4.cart.removeProduct( objFormData );
        }
    },
    favoritelist: {
        bindEvents: function () {
            jQuery( '.js-e-product-favorite-list-form' ).on( 'submit', function ( event ) {
                event.preventDefault();
            } ).on( 'change', '.js-e-favorite-list', function ( event ) {
                e4.product.favoritelist.toggleList( event.target );
            } );
        },
        toggleList: function ( domInput ) {
            var jInput = jQuery( domInput );
            if ( jInput.prop( 'checked' ) === true ) {
                e4.product.favoritelist.addToList( jInput );
            }
            else {
                e4.product.favoritelist.removeFromList( jInput );
            }
        },
        addToList: function ( jInput ) {
            jInput.prop( 'disabled', true );
            e4.cc.ajax( {
                url: jInput.data( 'url-add' ) + '&Redirect=false'
            }, function () {
                jInput.prop( 'disabled', false );
            } );
        },
        removeFromList: function ( jInput ) {
            jInput.prop( 'disabled', true );
            e4.cc.ajax( {
                url: jInput.data( 'url-remove' ) + '&Redirect=false'
            }, function () {
                jInput.prop( 'disabled', false );
            } );
        }
    }
};
